module.exports = __webpack_public_path__ + "media/images/icon_popup_close_sp_60-60-754a84694714d17b857a168e98104be8.png";